<template>
  <div
    class="main-wrapper"
    ref="tooltip"
    :style="contentStyle"
  >
    <div
      class="tooltip-wrapper"
      ref="tooltipContent"
    >
      <slot name="content"></slot>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    position: {
      type: Object,
    },
    chartWidth: {
      type: Number,
      required: true,
    },
    dataWidth: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      contentStyle: '',
      margin: 16,
    };
  },
  computed: {
    positionLeft() {
      const left = this.position && this.position.left ? this.position.left : 0;

      return this.dataWidth / 2 + left;
    },
    positionTop() {
      return this.position && this.position.top ? this.position.top : 0;
    },
    startsFromTop() {
      return this.position?.fromCorner?.vertical === 'top';
    },
    startsFromBottom() {
      return this.position?.fromCorner?.vertical === 'bottom';
    },
    startsFromLeft() {
      return this.position?.fromCorner?.horizontal === 'left';
    },
    startsFromRight() {
      return this.position?.fromCorner?.horizontal === 'right';
    },
    translateVertically() {

      if (this.startsFromTop) {
        return this.margin;
      }

      if (this.startsFromBottom) {
        return -(this.$refs.tooltip.offsetHeight + this.margin);
      }

      return -(this.$refs.tooltip.offsetHeight / 2);
    },
    translateHorizontally() {
      if (this.startsFromLeft) {
        return this.margin;
      }

      if (this.startsFromRight) {
        return -(this.$refs.tooltip.offsetWidth + this.margin);
      }

      const totalTooltipWidth = this.$refs.tooltip.offsetWidth + this.margin;
      const maxXTooltip = this.positionLeft + totalTooltipWidth;

      return this.chartWidth < maxXTooltip
        ? -totalTooltipWidth
        : this.margin;
    },
  },
  mounted() {
    this.contentStyle = `top: ${this.positionTop + this.translateVertically}px;` +
                        `left: ${this.positionLeft + this.translateHorizontally}px;`;
  },
};
</script>

<style scoped>
  .main-wrapper {
    z-index: 1;
    display: inline-block;
    position: absolute;
  }

  .tooltip-wrapper {
    position: relative;
    min-width: 150px;
    max-width: 250px;
    color: #223448;
    background: rgba(255, 255, 255, 0.95);
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.4);
    border-radius: 4px;
    font-family: Lato;
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 14px;
  }
</style>
